import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {SmallPopover} from 'icsoc-antd-ex';
import EnterTableList from 'Components/union/enterTableList';
import CommonTable from 'Components/common/commonTable';
import IconFont from 'Components/common/iconFont';
import companyInfoActions from 'Actions/enterpriseConfig/enterpriseConfig';

const columns = showConfigModal => [
  {
    title: '序号',
    key: 'key',
    dataIndex: 'key',
    width: '3%',
    fixed: 'left',
    render: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: '企业ID',
    dataIndex: 'vccId',
    key: 'vccId',
    width: '10%',
    render: text => text || '--',
  },
  {
    title: '转人工号码',
    dataIndex: 'transferNumbers',
    key: 'transferNumbers',
    width: '15%',
    render: text => text || '--',
  },
  {
    title: '并发数',
    dataIndex: 'projectNum',
    key: 'projectNum',
    width: '10%',
    render: text => text || '--',
  },
  {
    title: '最大振铃时长',
    key: 'callTimeOut',
    dataIndex: 'callTimeOut',
    width: '10%',
    render: text => text || '--',
  },
  {
    title: '回调地址',
    key: 'callbackUrl',
    dataIndex: 'callbackUrl',
    width: '15%',
    render: text => text || '--',
  },
  {
    title: 'AppId',
    key: 'appId',
    dataIndex: 'appId',
    width: '20%',
    render: text => text || '--',
  },
  {
    title: 'AppSecret',
    key: 'appSecret',
    dataIndex: 'appSecret',
    width: '20%',
    render: text => text || '--',
  },
  {
    title: '操作',
    dataIndex: 'operate',
    key: 'operate',
    width: '2%',
    fixed: 'right',
    render: (text, record) => {
      return (
        <div className="operate">
          <SmallPopover type="white" content="编辑" className="tooltip">
            <IconFont
              type="icon-robotedit"
              onClick={() => showConfigModal(record)}
            />
          </SmallPopover>
        </div>
      );
    },
  },
];

class TableList extends EnterTableList {
  handleConfigAction = record => {
    const {actions, setConfigModalVisible} = this.props;
    actions.setConfigModalData(record);
    setConfigModalVisible();
  };

  render() {
    const {tableListData = [], loading} = this.props;

    return (
      <CommonTable
        style={{marginTop: 20}}
        columns={columns(this.handleConfigAction)}
        pagination={{position: 'none'}}
        dataSource={tableListData}
        rowKey="id"
        loading={loading}
        extraHeight={20}
        scroll={{x: '110%'}}
        onChange={this.handleTableChange}
      />
    );
  }
}

const mapStateToProps = ({enterpriseConfig}) => ({
  tableListData: enterpriseConfig.tableListData,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(companyInfoActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableList);
